
  import {Component, Vue} from 'vue-property-decorator';

  @Component
  export default class Header extends Vue {
    public readonly routes = {
      LANDING: '/',
      DOWNLOAD: '/download',
      SUPPORT: '/support',
      ABOUT: '/about'
    };
    public cdnUrl(path: string): string {
      return path;
    }
  }
